import { useSelector } from 'react-redux';
import AuthEmailPhoneNumberVerification from 'auth/magic_link/AuthEmailPhoneNumberVerification';
import AuthSsnVerification from 'auth/magic_link/AuthSsnVerification';
import React from 'react';

function AuthIdentityVerification({ navigate }) {
  const ssnConfirmed = useSelector((state) => state.ssnConfirmed);

  if (ssnConfirmed) {
    return <AuthEmailPhoneNumberVerification navigate={navigate} />;
  }
  return <AuthSsnVerification navigate={navigate} />;
}

export default AuthIdentityVerification;
